/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Button from '@mui/material/Button';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import styles from './UserFeedbackButton.module.scss';

export default function UserFeedbackButton() {
  return (
    <Button
      variant="outlined"
      id="userfeedback_button"
      startIcon={<BorderColorOutlinedIcon />}
      className={styles.button}
    >
      <span className={styles.text}>Feedback</span>
    </Button>
  );
}
